import { useMemo } from 'react';

export const useRowsAccrualBalance = (ptoBalancesEmployee) =>
  useMemo(() => {
    const result = Object.entries(ptoBalancesEmployee.data || {}).reduce(
      (acc, [key, value]) => {
        let rows = Object.entries(value).map(([name, values]) => ({
          name,
          ...values,
        }));

        // Sorting rows by start
        rows = rows.sort((a, b) => (a.start || 0) - (b.start || 0));

        acc.push({
          name: key,
          rows,
        });

        return acc;
      },
      []
    );
    return result;
  }, [ptoBalancesEmployee]);
